import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import MaintenanceReportGrid from './components/MaintenanceReportGrid';

function MaintenanceReportView(props) {
  const { t } = useTranslation();
  const pageTitle = t('reports.alarmMaintenance');

  const { cust_id: customerId, sitegroup_id: siteGroupId } = props.match.params;

  return (
    <AppNav flex page="customer_reports_maintenance" notFullHeight>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', px: 2, pb: 1 }}>
        <TitleBar showBackButton title={pageTitle} />
        <MaintenanceReportGrid customerId={customerId} siteGroupId={siteGroupId} />
      </Box>
    </AppNav>
  );
}

export default MaintenanceReportView;
